import { render, staticRenderFns } from "./badges_info.vue?vue&type=template&id=7b07c5bc&scoped=true&"
import script from "./badges_info.vue?vue&type=script&lang=js&"
export * from "./badges_info.vue?vue&type=script&lang=js&"
import style0 from "./badges_info.vue?vue&type=style&index=0&id=7b07c5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07c5bc",
  null
  
)

export default component.exports